<!-- 大图banner -->
<template>
  <section class="topBlock">
      <div class="banner oneBanner workBanner">
        <el-carousel height="460px" :autoplay="false" arrow="never">
          <el-carousel-item>
              <div class="container">
                  <div class="bannerLink">
                      <h3>智能工作室</h3>
                      <p>工作室项目培养技术实践型人才</p>
                      <a class="btn bigBtn whiteSty" href="#" @click="createStudio">成立工作室</a>
                      <a class="btn bigBtn whiteLineSty" href="#" v-if="false">查看列表</a>
                  </div>
                  <div class="img"><img src="@/pages/frontend/assets/images/banner_work.png"></div>
              </div>
          </el-carousel-item>
      </el-carousel>
      </div>

      <!-- 查询 -->
      <!-- <div class="bannerLink">
          <h3>智能工作室</h3>
          <p>工作室项目培养技术实践型人才</p>
          <a class="btn bigBtn whiteSty" href="#">成立工作室</a>
          <a class="btn bigBtn whiteLineSty" href="#">查看列表</a>
      </div> -->

      <!-- 会员中心 -->
      <!-- <div class="uCenter">
        <div class="info">
          <div class="userImg">
            <img src="images/headIcons.png">
          </div>
          <div class="userName">
            <div class="name">王小明</div>
            <p>下午好，欢迎回来！</p>
          </div>
        </div>
        <div class="msg">
          <a>
            <h3>职位申请</h3>
            <p><span>10</span>份</p>
          </a>
          <a>
            <h3>面试邀请</h3>
            <p><span>5</span>份</p>
          </a>
        </div>
        <div class="notices">
          <ul>
            <li><a>系统通知：您的人才需求审核通过才能正常使用</a></li>
            <li><a>系统通知：平台升级啦，查看新功能</a></li>
          </ul>
        </div>
        <a class="btn bigBtn blueSty ucLink" href="#">个人中心</a>
      </div> -->
  </section>
</template>
<script>
    export default {
        name: 'Banner',
        methods:{
            createStudio(){
                window.open('https://www.wjx.cn/m/58575849.aspx');
            }
        }
    }
</script>
<style scoped>
    @import "~@/pages/frontend/assets/css/workroom.css";
</style>